import { render } from "./WysiwygEditor.vue?vue&type=template&id=37fa4d5a"
import script from "./WysiwygEditor.vue?vue&type=script&lang=js"
export * from "./WysiwygEditor.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__